import React from "react";

const Hero = () => {
  return (
    <div>
      <section
        className="text-dark text-center pb-5 pt-4 bg-image"
        style={{ height: "100vh" }}
      >
        <div className="container hero">
          <h1 className="display-4">
            The Fastest Way to Build & Scale <br />
            <span
              style={{
                fontWeight: "300",
                letterSpacing: "0px",
              }}
            >
              Your Online Store
            </span>
          </h1>

          <div className="col-lg-12 text-center mx-auto">
            <div className="row">
              <div className="col-lg-6 text-center mx-auto">
                <p className="text-uppercase mt-2">
                  A powerful multi-tenant Headless CMS for eCommerce.
                </p>
              </div>
              <div>
                <img
                  src="assets/images/store.png"
                  width={363}
                  className="img-fluid d-block"
                  style={{ margin: "0 auto" }}
                  alt=""
                />
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="d-flex justify-content-center gap-3 mt-5 flex-wrap">
            <a
              href="https://app.fexila.com/register"
              className="btn btn-primary"
              style={{
                fontWeight: 600,
                width: "265px",
                border: "2px solid #cb3a3a",
              }}
            >
              <img
                src="assets/images/lock.png"
                alt=""
                style={{ display: "inline-block", marginRight: "6px" }}
              />
              Start your 14-day FREE trial
            </a>

            <a
              href="https://youtu.be/TFZl1xWUqGU"
              target="_blank"
              rel="noopener noreferrer"
              className="btn"
              style={{
                fontWeight: 600,
                width: "265px",
                border: "2px solid #000",
                color: "#fff", // White text for contrast
                backgroundColor: "#000", // Black background
              }}
            >
              <img
                src="assets/images/play.png"
                alt="Play"
                style={{ display: "inline-block", marginRight: "8px" }}
                width={18}
              />
              Watch 1.5 Minute Demo Video
            </a>
          </div>

          <p style={{ marginTop: "65px" }}>
            Seamlessly connect to any frontend: React, Next.js, Vue, or even
            PHP.
          </p>

          <div className="framework mb-5 d-flex align-items-center justify-content-center gap-3">
            <img src="assets/images/react.png" alt="react" width="55px" />
            <img src="assets/images/vue.png" alt="vue" width="55px" />
            <img
              src="assets/images/angular.png"
              alt="angular"
              width="35px"
              style={{ marginLeft: "10px" }}
            />
            <img
              src="assets/images/node.png"
              alt="node"
              width="35px"
              style={{ marginLeft: "15px" }}
            />
          </div>
        </div>
      </section>

      <div className="container mx-auto position-relative">
        <section style={{ paddingBottom: "120px" }}>
          <div className="row">
            <div className="col-lg-12 text-center mx-auto">
              <img
                src="assets/images/hero.png"
                alt=""
                className="hero-image img-fluid mx-auto d-block shadow-lg"
              />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Hero;
